package ai.wagemix.net.client

import ai.wagemix.net.models.WMSharedMixActivation
import com.fsryan.foundation.net.client.FSAuthenticatedRequestBuilder
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.contentTypeJson
import com.fsryan.foundation.net.client.pathParamFollowing
import com.fsryan.foundation.net.client.replacePathParams

/**
 * `PUT /api/v1/sharedMixes/{id}/active`: turns one of the caller's share links on or off. Only its owner may (404
 * otherwise); 204 when done.
 */
class WMSetSharedMixActiveRequestBuilder:
    FSAuthenticatedRequestBuilder<WMSetSharedMixActiveRequestBuilder, WMSharedMixActivation>() {

    private var sharedMixId: String? = null

    fun sharedMixId(sharedMixId: String): WMSetSharedMixActiveRequestBuilder {
        this.sharedMixId = sharedMixId
        return this
    }

    override fun applyFrom(request: FSRequest<WMSharedMixActivation>): WMSetSharedMixActiveRequestBuilder {
        sharedMixId = request.pathParamFollowing("sharedMixes")
        return super.applyFrom(request)
    }

    override fun build(): FSRequest<WMSharedMixActivation> {
        method(FSRequest.Method.Put)
        val id = sharedMixId ?: error("A shared mix id must be provided")
        replacePathParams("api", "v1", "sharedMixes", id, "active")
        contentTypeJson()
        return super.build()
    }

    override fun clear(): WMSetSharedMixActiveRequestBuilder {
        sharedMixId = null
        return super.clear()
    }

    override fun self(): WMSetSharedMixActiveRequestBuilder = this
}
